import React, { useState, useEffect } from "react";
import {
Menu,
Select,
Space,
Dropdown,
Button,
message,
Radio,
Tag,
Row,
Switch,
Pagination,
Input,
Col,
Typography,
AutoComplete } from
"antd";
import { DownOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import Location from "../components/LocationFilter/LocationFilter";
import City from "../components/LocationFilter/CityFilter";
import Region from "../components/LocationFilter/RegionFilter";
import State from "../components/LocationFilter/StateFilter";
import ExperienceLevel from "../components/ExperienceLevelFilter/ExperienceLevelFilter";
import BudgetFilter from "../components/BudgetFilter/BudgetFilter";
import FilterLocation from "../components/LocationFilter/location.filter";
import { HidePreviouslyViewedFilter } from "../components/HidePreviouslyViewedFilter";
import { LoadingOutlined } from "@ant-design/icons";
import { ProfessionFilter } from "../components/professionFilter/professionFilter";
import PreviousIndustries from "../components/LocationFilter/PreviousIndustries";
import Companies from "../components/LocationFilter/Companies";
import VisaFilter from "../components/LocationFilter/filter.visa";
import ExperienceLevelFilter from "../components/LocationFilter/filter.ExperienceLevels";
import { useParams } from "react-router-dom";
import SkillFilter from "../components/LocationFilter/SkillFilter";import { isNonHC } from "../../../shared/helpers";
import "./Filters.css";

const Filters = (props) => {
  const { Text } = Typography;
  const [sortOption, setSortOption] = useState("MOST_RELEVANT");
  const [sortText, setSortText] = useState('');
  const [skillType, setSkillType] = useState(null);
  const [visible, setVisible] = useState(false);
  const { id, name } = useParams();

  useEffect(() => {
    if (sortOption == "New skill listing") {
      setSortText("MOST_RECENT");
    } else
    {

      setSortText(sortOption);
    }
  }, [sortOption]);

  window.sort = sortText;
  const { Option } = Select;
  window.skillType = skillType;

  const Count = useSelector(
  (state) => state.searchSkillListingReducer.skillListingCount);


  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const countLoading = useSelector(
  (state) => state.searchSkillListingReducer.countLoading);


  useEffect(() => {
    if (props.selectedOption) {
      if (props?.selectedOption == "MOST_RECENT") {
        setSortOption("New skill listing");
      } else
      {
        setSortOption(props.selectedOption);
      }
      props?.setSort(props.selectedOption);
    }
  }, []);

  const ExperienceName = [
  { id: 5, value: 'US Resident/Citizen' },
  { id: 9, value: 'EAD' },
  { id: 8, value: 'H1-B' }];


  const getCheckedValues = (value2) => {
    const commonValues = ExperienceName?.filter((experience) =>
    value2?.some((selectedExp) => selectedExp?.id === experience?.id));

    return commonValues?.map((item) => item?.value);
  };

  const handleChange = (val) => {

    props?.setCheckVisa(val?.map((item) => {
      switch (item) {
        case 'US Resident/Citizen':
          return { id: 5, name: 'US Resident/Citizen' };
        case 'EAD':
          return { id: 9, name: 'EAD' };
        case 'H1-B':
          return { id: 8, name: 'H1-B' };
        default:
          return item; // If item doesn't match any replacements, keep it unchanged
      }
    }));
    props?.setCheckVisaIdArray(
    val?.map((item) => {
      switch (item) {
        case 'US Resident/Citizen':
          return parseInt(5);
        case 'EAD':
          return parseInt(9);
        case 'H1-B':
          return parseInt(8);
        default:
          return item; // If item doesn't match any replacements, keep it unchanged
      }
    }));

  };

  const handleCountryChange = (flag) => {
    if (flag) {
      if (props.emptyCountryInput === "") {
        props.setEmptyCountryInput();
      }
    }
    {





      /* if (!flag) {
      setEmptyCountryInput("");
      } */}setVisible(flag);};const sortOptionSelected = (e) => {
    props?.setSort(e);
    if (e.target.value == "MOST_RECENT") {
      setSortOption("New skill listing");
    } else
    {
      setSortOption(e.target.value);
    }
    props?.setClearSort(false);
  };

  const skillTypeSelected = (e) => {
    props.setJobTypeRadios(e.target.value);
    props.addQuery("skillListing_type", e.target.value);
  };
  const candidateTypeSelected = (e) => {
    props.setcandidateTypeRadio(e.target.value);
    props.addQuery("isPrivateTalent", e.target.value);
  };

  useEffect(() => {
    if (props?.clearSort) {
      setSortOption("");
      window.sort = null;
    }
  }, [props?.clearSort]);

  const countFromValue = (item) => {
    const matchingCount = Count?.result?.visaStatusCount?.find(
    (count) => count?.title === item);


    const count = matchingCount ? matchingCount.count : 0;
    return count;
  };

  const PrevMenu =
  // <Menu className="location-filter-menu">
  <Menu
  // className={`location-filter-menu ${filterError === "region" && "filterError"
  //   }`}
  >
      <div className="location-filter-menu-inner">
        Lorem ipsum
        {/* <FilterRegion
                setregionObj={setCheckRegionObject}
                regionObj={checkRegionObject}
                setcheck={setCheckRadioRegion}
                check={checkRadioRegion}
                setFilter={setFilter}
                setCheckRegionId={setCheckRegionId}
                checkRegionId={checkRegionId}
                addQuery={addQuery}
                emptyRegionInput={emptyRegionInput}
                setEmptyRegionInput={setEmptyRegionInput}
                searchLocationFilter={searchLocationFilter}
              /> */}
        {/* {filterError === "region" && checkRadioRegion?.length <= 0 && (
        <div className="filter-error-style">Please select region</div>
        )} */}
        {/* <ClearAll type="region" /> */}
      </div>
    </Menu>;

  return (
    <>
      {props.prop ?
      <Col sm={24} xs={24} className="filters-container-mobile">
          {!props.authToken ?
        <ProfessionFilter
        // setFilterError={setFilterError}
        windowDimensions={props.windowDimensions}
        setProfessionSelected={props.setProfessionSelected}
        ClearAll={props.ClearAll}
        setProfessionDropdownOpen={props.setProfessionDropdownOpen}
        professionDropdownOpen={props.professionDropdownOpen}
        searchFilters={props.searchFilters}
        professionSelected={props.professionSelected} /> :


        ""}
        
          <Text className="filter-heading">Skill listing type</Text> <br />
          <Radio.Group
        onChange={skillTypeSelected}
        value={props?.jobTypeRadio?.replace("+", " ")}
        className="Selected-type"
        style={{ marginBottom: "5%", width: "100%" }}>
          
            <Space direction="vertical" style={{ width: "100%" }}>
              <div
            className="radios"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between"
            }}>
              
                <Radio value={"Contract"}>Contract</Radio>
                {props?.fromCandMkt || id ? null : countLoading ?
              <LoadingOutlined className="loading" /> :
              Count?.result?.gigCount?.findIndex(
              (e) => e.title === "Contract") !=
              -1 &&
              !props.gqlError &&
              props.totalCountError == 0 ?
              <div className="countDiv">
                    (
                    {
                Count?.result?.gigCount[
                Count?.result?.gigCount?.findIndex(
                (e) => e.title === "Contract")]?.

                count}
                
                    )
                  </div> :

              <div className="countDiv">(0)</div>}
              
              </div>

              <div
            className="radios"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between"
            }}>
              
                <Radio value={"Permanent"}>Permanent</Radio>
                {props?.fromCandMkt || id ? null : countLoading ?
              <LoadingOutlined className="loading" /> :
              Count?.result?.gigCount?.findIndex(
              (e) => e.title === "Permanent") !=
              -1 &&
              !props.gqlError &&
              props.totalCountError == 0 ?
              <div className="countDiv">
                    (
                    {
                Count?.result?.gigCount[
                Count?.result?.gigCount?.findIndex(
                (e) => e.title === "Permanent")]?.

                count}
                
                    )
                  </div> :

              <div className="countDiv">(0)</div>}
              
              </div>

              {isNonHC(userProfile?.Professions?.ProfessionCode) ? null :
            <div
            className="radios"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between"
            }}>
              
                  <Radio value={"Per Diem"}>Per diem</Radio>

                  {props?.fromCandMkt || id ? null : countLoading ?
              <LoadingOutlined className="loading" /> :
              Count?.result?.gigCount?.findIndex(
              (e) => e.title === "Per Diem") !=
              -1 &&
              !props.gqlError &&
              props.totalCountError == 0 ?
              <div className="countDiv">
                      (
                      {
                Count?.result?.gigCount[
                Count?.result?.gigCount?.findIndex(
                (e) => e.title === "Per Diem")]?.

                count}
                
                      )
                    </div> :

              <div className="countDiv">(0)</div>}
              
                </div>}
            
            </Space>
          </Radio.Group>{" "}
          <br />
          {/* Skill */}
          <Text className="filter-heading">Skill</Text> <br />
              <SkillFilter
        setskillObj={props.setskillObj}
        skillObj={props.skillObj}
        setcheck={props.setcheckSkill}
        check={props.checkSkill}
        setFilter={props.setFilterSkill}
        addQuery={props.addQuerySkill}
        checkSkillId={props.checkSkillId}
        setCheckSkillId={props.setCheckSkillId}
        emptySkillInput={props.emptySkillInput}
        setEmptySkillInput={props.setEmptySkillInput}
        searchLocationFilter={props.searchLocationFilterSkill}
        countCheck={props.countCheck} />
        
          {/* //country */}
          <Text className="filter-heading">Country</Text> <br />
          <State
        setcountryObj={props.setcountryObj}
        setPrevIndustryObj={props.setPrevIndustryObj}
        countryObj={props.countryObj}
        setCheck={props.setCheckRadioCountry}
        check={props.checkRadioCountry}
        setCheckCountryId={props.setCheckCountryId}
        checkCountryId={props.checkCountryId}
        addQuery={props.addQuery}
        removeQuerry={props.removeQuerry}
        fromCandMkt={props?.fromCandMkt}
        emptyCountryInput={props.emptyCountryInput}
        setEmptyCountryInput={props.setEmptyCountryInput}
        searchLocationFilter={props?.searchLocationFilter}
        region={props.checkRadioRegion}
        city={props.checkRadioLoc}
        jobId={id} />
        
          {/* //state */}
          <Text className="filter-heading">State</Text> <br />
          <Region
        setregionObj={props.setregionObj}
        regionObj={props.regionObj}
        setCheck={props.setCheckRadioRegion}
        check={props.checkRadioRegion}
        setCheckRegionId={props.setCheckRegionId}
        checkRegionId={props.checkRegionId}
        addQuery={props.addQuery}
        removeQuery={props.removeQuery}
        emptyRegionInput={props.emptyRegionInput}
        setEmptyRegionInput={props.setEmptyRegionInput}
        searchLocationFilter={props?.searchLocationFilter}
        country={props.checkRadioCountry}
        city={props.checkRadioLoc}
        fromCandMkt={props?.fromCandMkt} />
        
          {/* city */}
          <Text className="filter-heading">City</Text> <br />
          <Location
        setlocObj={props.setlocObj}
        locObj={props.locObj}
        setCheck={props.setCheckRadioLoc}
        check={props.checkRadioLoc}
        setCheckCityId={props.setCheckCityId}
        checkCityId={props.checkCityId}
        addQuery={props.addQuery}
        removeQuerry={props.removeQuerry}
        emptyCityInput={props.emptyCityInput}
        setEmptyCityInput={props.setEmptyCityInput}
        searchLocationFilter={props?.searchLocationFilter}
        country={props.checkRadioCountry}
        region={props.checkRadioRegion} />
        
          <Text className="filter-heading">Experience level</Text> <br />
          {/* <ExperienceLevel
          fromCandMkt={props?.fromCandMkt}
          checkBox={props.checkBox}
          setCheckedBox={props.setCheckedBox}
          setFilter={props.setFilter}
          check={props.check}
          setcheck={props.setcheck}
          addQuery={props.addQuery}
          totalCountError={props.totalCountError}
          gqlError={props.gqlError}
          /> */}
          <ExperienceLevelFilter
        fromCandMkt={props?.fromCandMkt}
        checkBox={props.checkBox}
        setCheckedBox={props.setCheckedBox}
        setFilter={props.setFilter}
        check={props.check}
        setcheck={props.setcheck}
        addQuery={props.addQuery}
        totalCountError={props.totalCountError}
        gqlError={props.gqlError} />
        
          {/* //Visa Status */}
          {/* <br /> */}
          <Text className="filter-heading">Visa status</Text> <br />
          {/* <VisaFilter
          setcheck={props?.setCheckVisa}
          check = {props?.checkRadioVisa}
          /> */}
          <Select
        value={getCheckedValues(props?.checkVisa)}
        // placeholder="Citizen, Resident/Citizen"
        placeholder="Visa status"
        onChange={handleChange}
        mode="multiple"
        style={{ width: "100%", height: "4rem" }}
        className="select-tag"
        optionLabelProp="label">
          
            {/* <Option value={"Citizen"}>Citizen</Option> */}
            <Option
          value={"US Resident/Citizen"}
          label={"US Resident/Citizen"}
          key={"US Resident/Citizen"}>
            
              <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}>
              
                <div>US Resident/Citizen</div>
                <div className="countDiv">
                  {props?.fromCandMkt || id ?
                null :
                "(" + countFromValue("US Resident/Citizen") + ")"}
                </div>
              </div>
            </Option>
            <Option value={"EAD"} label={"EAD"} key={"EAD"}>
              <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}>
              
                <div>EAD</div>
                <div className="countDiv">
                  {props?.fromCandMkt || id ?
                null :
                "(" + countFromValue("EAD") + ")"}
                </div>
              </div>
            </Option>
            <Option value={"H1-B"} label={"H1-B"} key={"H1-B"}>
              <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}>
              
                <div>H1-B</div>
                <div className="countDiv">
                  {props?.fromCandMkt || id ?
                null :
                "(" + countFromValue("H1-B") + ")"}
                </div>
              </div>
            </Option>
          </Select>
          {/* //Previous Industries */}
          {isNonHC(userProfile?.Professions?.ProfessionCode) ?
        <>
              <br />
              <Text className="filter-heading">Industry</Text> <br />
              <PreviousIndustries
          setPrevIndustryObj={props?.setPrevIndustryObj}
          prevIndustryObj={props?.prevIndustryObj}
          checkIndustryObject={props?.checkIndustryObject}
          setCheckIndustryObject={props?.setCheckIndustryObject}
          setCheck={props?.setIndustryRadioCheck}
          check={props?.industryRadioCheck}
          setFilter={props.setFilter}
          addQuery={props.addQuery}
          setCheckIndustryId={props.setCheckIndustryId}
          checkIndustryId={props.checkIndustryId}
          setEmptyIndustryInput={props?.setEmptyIndustryInput}
          emptyIndustryInput={props?.emptyIndustryInput}
          searchLocationFilter={props?.searchLocationFilter}
          fromCandMkt={props?.fromCandMkt} />
          
            </> :
        null}
          {/* //Companies */}
          <Text className="filter-heading">Company</Text> <br />
          <Companies
        setCheck={props?.setcheckCompany}
        check={props?.checkCompany}
        setFilterCompany={props?.setFilterCompany}
        addQueryCompany={props?.addQueryCompany}
        emptyCompanyInput={props?.emptyCompanyInput}
        setEmptyCompanyInput={props?.setEmptyCompanyInput}
        searchLocationFilter={props?.searchLocationFilter}
        fromCandMkt={props?.fromCandMkt} />
        
          {props?.showCandidateType ?
        <>
              <Text className="filter-heading">All candidates</Text> <br />
              <Radio.Group
          onChange={candidateTypeSelected}
          value={props?.candidateTypeRadio || "true"}
          className="Selected-type"
          style={{ marginBottom: "5%", width: "100%" }}>
            
                <Space direction="vertical" style={{ width: "100%" }}>
                  <div
              className="radios"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}>
                
                    <Radio value={"false"}>All candidates</Radio>
                    <div className="countDiv">
                      {/* ({props?.candidateCounts?.data?.[0]?.allCandidates || 0}) */}
                    </div>
                  </div>

                  <div
              className="radios"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}>
                
                    <Radio value={"true"}>Private candidates</Radio>
                    <div className="countDiv">
                      {/* ({props?.candidateCounts?.data?.[0]?.isPrivate || 0}) */}
                    </div>
                  </div>
                </Space>
              </Radio.Group>{" "}
            </> :
        null}
          {/* {isNonHC(userProfile?.Professions?.ProfessionCode) ? null : ( */}
          <>
            <div style={{ marginTop: "4.2%", height: "1px" }}>
              <Text className="filter-heading">Budget</Text>
            </div>{" "}
            <br />
            <BudgetFilter
          setFilter={props.setFilter}
          setClear={props.setClear}
          setBudget={props.setBudget}
          budget={props.budget}
          clear={props.clear}
          addQuery={props.addQuery}
          // setFilterError={props.setFilterError}
          />
          </>
          {/* )} */}
          {/* {props.authToken != null && (
          <HidePreviouslyViewedFilter
            hideCheck={props.hideCheck}
            setHideCheck={props.setHideCheck}
            searchFilters={props.searchFilters}
            setSearchFilters={props.setSearchFilters}
          />
          )} */}
        </Col> :

      <Col sm={24} xs={24} className="filters-container">
          <Radio.Group
        style={{ marginBottom: "5%", width: "100%" }}
        value={sortOption}
        onChange={sortOptionSelected}>
          
            <Space direction="vertical" style={{ width: "100%" }}>
              {isNonHC(userProfile?.Professions?.ProfessionCode) ?
            <>
                  {props.fromSearch ?
              <Radio className="radios" value={"MOST_RELEVANT"}>
                      Most relevant
                    </Radio> :
              null}
                  <Radio className="radios" value={"New skill listing"}>
                    New skill listing
                  </Radio>
                  <Radio className="radios" value={"MOST_NEWEST"}>
                    Last active
                  </Radio>
                  <Radio className="radios" value={"RATINGS_HIGH_TO_LOW"}>
                    Ratings high to low
                  </Radio>
                  <Radio className="radios" value={"RATINGS_LOW_TO_HIGH"}>
                    Ratings low to high
                  </Radio>
                </> :

            <>
                  {/* {props.fromSearch ? (
                <Radio className="radios" value={"MOST_RELEVANT"}>
                Most relevant
                </Radio>
                ) : null} */}

                  <Radio className="radios" value={"MOST_RELEVANT"}>
                    Most relevant
                  </Radio>

                  <Radio className="radios" value={"New skill listing"}>
                    New skill listing
                  </Radio>
                  <Radio className="radios" value={"MOST_NEWEST"}>
                    Last active
                  </Radio>
                  <Radio className="radios" value={"RATINGS_HIGH_TO_LOW"}>
                    Ratings high to low
                  </Radio>
                  <Radio className="radios" value={"RATINGS_LOW_TO_HIGH"}>
                    Ratings low to high
                  </Radio>
                  <Radio className="radios" value={"PAY_HI_TO_LOW"}>
                    Desired rate high to low
                  </Radio>
                  <Radio className="radios" value={"PAY_LOW_TO_HI"}>
                    Desired rate low to high
                  </Radio>
                </>}
            
            </Space>
          </Radio.Group>
        </Col>}
      
    </>);

};
export default Filters;